import { TemplateElement, html, defineElement, when, optionalAttribute } from '@webtides/element-js';
import style from './e-banking-section-headline.css';

/**
 * @property {string} headline - Headline
 * @property {string} [subline] - Optional subline
 */
export default class SectionHeadline extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            headline: '',
            subline: '',
        };
    }

    template() {
        return html`
            <div class="flex flex-col">
                <h2
                    class="text-[26px] font-medium text-green-medium mb-0 lining-nums tabular-nums"
                    ${optionalAttribute(this.kicker?.text, 'aria-label', `${this.kicker?.text} - ${this.headline}`)}
                >
                    ${this.headline}
                </h2>
                ${when(this.subline, html`<p class="text-sm font-normal text-balance mb-0">${this.subline}</p>`)}
            </div>
        `;
    }
}

defineElement('mb-e-banking-section-headline', SectionHeadline);
